<template>
  <router-view />
</template>

<script>
export default {
  name: 'Contractors'
};
</script>

<style lang="scss" scoped></style>
